<template>
    <button
        class="btn btn--primary"
        :class="{'': !enableButton, 'btn--disable': enableButton}"
        :disabled="enableButton"
        @click="addToCart"
    >
        <icon-basket class=""/>
        <span>{{ processingForm ? `Adding to cart...` : `Add to cart` }}</span>
    </button>
</template>
<script>
import IconBasket from "../Icons/IconBasket";

export default {
    name: 'AddToCartButton',
    components: { IconBasket },
    props: {
        addToCart: {},
        enableButton: {},
        processingForm: {}
    }
}
</script>